/**
 * ResultScreen (S5) — success seal after a punch.
 * Props: { ctx, api, tg, nav, state, setState, params:{direction,time,branch} }
 *        (params also readable from state.result).
 *
 *   - direction 'in'  → seal.ok "✓", "Kirdingiz!", HH:MM, branch · date,
 *                       wish "Ishingizga omad! 💪".
 *   - direction 'out' → seal.io "👋", "Chiqdingiz!", .sumrow kirish/chiqish/jami,
 *                       wish "Yaxshi dam oling! 🌙".
 *   - MainButton "Bosh sahifaga qaytish" → nav.reboot() (re-fetch /session,
 *     reset stack to LANDING).
 */
import { useEffect } from 'react';
import Screen from '../components/Screen.jsx';
import Button from '../components/Button.jsx';
import { T, MONTH_UZ, hhmm } from '../lib/i18n.js';

function dateShort() {
  const d = new Date();
  const month = (MONTH_UZ[d.getMonth() + 1] || '').toLowerCase();
  return `${d.getDate()}-${month}`;
}

function minsOfDay(iso) {
  const m = /T(\d{2}):(\d{2})/.exec(iso || '');
  return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
}

function durationHM(inIso, outIso) {
  const a = minsOfDay(inIso);
  const b = minsOfDay(outIso);
  if (a == null || b == null) return '';
  let diff = b - a;
  if (diff < 0) diff += 24 * 60;
  const h = Math.floor(diff / 60);
  const m = diff % 60;
  return `${h}s ${String(m).padStart(2, '0')}m`;
}

export default function ResultScreen({ ctx, tg, nav, state, params }) {
  const p = params && params.direction ? params : state.result || {};
  const isIn = p.direction === 'in';
  const checkIn = ctx.today?.check_in;

  useEffect(() => {
    tg.haptic('success');
  }, [tg]);

  useEffect(() => {
    if (!tg.isTelegram) return undefined;
    return tg.MainButton.onClick(() => nav.reboot());
  });

  useEffect(() => {
    if (!tg.isTelegram) return undefined;
    tg.MainButton.setText(T.btn_back_home);
    tg.MainButton.enable();
    tg.MainButton.show();
    return () => tg.MainButton.hide();
  }, [tg]);

  return (
    <Screen
      footer={
        !tg.isTelegram ? (
          <Button onClick={() => nav.reboot()}>{T.btn_back_home}</Button>
        ) : null
      }
    >
      <div className="res">
        <div className={`seal ${isIn ? 'ok' : 'io'}`}>{isIn ? '✓' : '👋'}</div>
        <div className="res-h">{isIn ? T.result_in_h : T.result_out_h}</div>

        {isIn ? (
          <>
            <div className="res-t">{hhmm(p.time)}</div>
            <div className="res-s">
              {[p.branch, dateShort()].filter(Boolean).join(' · ')}
            </div>
            <div className="res-s" style={{ color: 'var(--ok)', fontWeight: 650 }}>
              {T.result_in_wish}
            </div>
          </>
        ) : (
          <>
            <div className="sumrow">
              <div>{T.label_checkin}<b>{hhmm(checkIn) || '—'}</b></div>
              <div>{T.label_checkout}<b>{hhmm(p.time) || '—'}</b></div>
              <div>{T.label_total}<b>{durationHM(checkIn, p.time) || '—'}</b></div>
            </div>
            <div className="res-s" style={{ marginTop: 6 }}>{T.result_out_wish}</div>
          </>
        )}
      </div>
    </Screen>
  );
}
